export default __webpack_public_path__ + "static/media/iphone_02.5d050b39.png";